import { useRecoilValue, useSetRecoilState } from "recoil";
import { useEffect, useMemo } from "react";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import { mapContentsVisibleWithID } from "../../../store/MapContentsState";
import { addMapLegendSelector, removeMapLegendSelector } from "../../../store/MapLegendState";

function ContentsDispatcher({contentsID, contents}) {
  const visible = useRecoilValue(mapContentsVisibleWithID(contentsID));
  const dependency = useMemo(() => ([visible]), [visible]);
  const addMapLegend = useSetRecoilState(addMapLegendSelector);
  const removeMapLegend = useSetRecoilState(removeMapLegendSelector);

  useEffect(() => {
    if (visible) {
      contents.drawLayer(visible);
      if (typeof contents.getLegend === 'function') {
        addMapLegend(contents.getLegend());
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffectSkipFirst(async() => {
    await contents.drawLayer(visible);

    if (typeof contents.getLegend === 'function') {
      if (visible) {
        addMapLegend(contents.getLegend());
      } else {
        removeMapLegend(contents.getLegend());
      }
    }
  }, dependency);

  //dont draw anything
  return null;
}

export default ContentsDispatcher